let envObj;
if (process.env.NODE_ENV === 'development') {
  envObj = {
    baseurl: 'https://srv-news.yinxianwl.com',
    // baseurl: 'https://srv-news-test.yinxianwl.com',
  };
}

if (process.env.NODE_ENV === 'production') {
  envObj = {
    baseurl: 'https://srv-news.yinxianwl.com',
    // baseurl: 'https://srv-news-test.yinxianwl.com',
  };
}

export default envObj;
